import type { GeneralSettings } from '~/types/api/settings'

export const useSocialLinks = () => {
  const socialLinksDefault: Partial<Pick<GeneralSettings, 'twitter' | 'facebook' | 'instagram' | 'pinterest' | 'youtube'>> = {}
  const socialLinks = useState('ysc:social-links', () => (socialLinksDefault))
  return { socialLinks }
}
